// extracted by mini-css-extract-plugin
export default {"rating_container":"Rating_rating_container__wDdXS","icon":"Rating_icon__aIoVn"};